import { render, staticRenderFns } from "./CloseBtn.vue?vue&type=template&id=aa48a536&scoped=true"
import script from "./CloseBtn.vue?vue&type=script&lang=js"
export * from "./CloseBtn.vue?vue&type=script&lang=js"
import style0 from "./CloseBtn.vue?vue&type=style&index=0&id=aa48a536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa48a536",
  null
  
)

export default component.exports